import React from "react";

// Debajo del campo "Persona" (Prestar y Gestionar > Modificar): en VERDE con
// quién queda enlazado el préstamo (ID y usuario) si se ha elegido a alguien
// que existe; en AMARILLO si es texto libre (no enlaza con ninguna cuenta).
// cuenta: {tipo_persona, id_persona, nombre, puesto, usuario} | null
export default function AvisoCuentaPersona({ texto, cuenta }) {
  if (!String(texto || "").trim()) return null;
  if (cuenta) {
    const tipo = cuenta.tipo_persona === "alumno" ? "Residente" : `Personal${cuenta.puesto ? ` (${cuenta.puesto})` : ""}`;
    return (
      <div className="aviso-cuenta ok">
        ✓ <b>{cuenta.nombre}</b> · {tipo} · ID <b>{cuenta.id_persona}</b>
        {cuenta.usuario ? <> · usuario <b>{cuenta.usuario}</b></> : null}
      </div>
    );
  }
  return (
    <div className="aviso-cuenta texto">
      ⚠️ <b>Texto libre:</b> no está enlazado a ninguna persona de personal ni residente. Si lo es, elígela del listado.
    </div>
  );
}

const norm = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/\s+/g, " ").trim();

// Si lo escrito coincide EXACTAMENTE (sin mayúsculas/acentos) con una sola
// persona del listado, se enlaza sola (sin tener que pinchar en ella).
export function coincidenciaExacta(texto, resultados) {
  const t = norm(texto);
  if (!t) return null;
  const iguales = (resultados || []).filter((x) => norm(x.nombre) === t);
  return iguales.length === 1 ? iguales[0] : null;
}

// Resultado de /buscar_persona -> cuenta para AvisoCuentaPersona.
export const cuentaDeResultado = (x) => ({
  tipo_persona: x.tipo_persona, id_persona: x.id_persona, nombre: x.nombre,
  puesto: x.tipo_persona === "alumno" ? "residente" : x.puesto,
  usuario: x.tipo_persona === "personal" ? x.id : null,
});
